import { render, staticRenderFns } from "./Paziente.vue?vue&type=template&id=342ac9dc&scoped=true&"
import script from "./Paziente.vue?vue&type=script&lang=js&"
export * from "./Paziente.vue?vue&type=script&lang=js&"
import style0 from "./Paziente.vue?vue&type=style&index=0&id=342ac9dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342ac9dc",
  null
  
)

export default component.exports